// @ts-nocheck
import React, { useCallback } from 'react';
import { Button, Intent } from '@blueprintjs/core';
import { compose } from '@/utils';
import { Icon, FormattedMessage as T } from '@/components';
import withDialogActions from '@/containers/Dialog/withDialogActions';

function ShippingAccountsActions({ openDialog }) {
  const handleClickNew = useCallback(() => {
    openDialog('shipping-account-form');
  }, [openDialog]);

  return (
    <div className="shipping-accounts-actions">
      <Button
        icon={<Icon icon="plus" iconSize={12} />}
        onClick={handleClickNew}
        intent={Intent.PRIMARY}
        style={{ backgroundColor: '#2196F3' }}
      >
        <T id={'new_shipping_account'} />
      </Button>
    </div>
  );
}

export default compose(withDialogActions)(ShippingAccountsActions);